import { useQuery } from 'react-query'
import { axios } from '../../../lib'
import { toast } from 'react-toastify'
import { AxiosResponse } from 'axios'

type Params = {
  productId: string
  identifyId: string
}

type Response = {
  weight: number
  hasWeightPrice: number
}

const fetcher = (data: Params): Promise<AxiosResponse<Response>> => {
  return axios.get(`orders/products/${data.productId}/weight`, {
    params: {
      identifyId: data?.identifyId
    }
  })
}

export function useLoadProductWeight(query: Params) {
  return useQuery(['loadProductWeight', query], () => fetcher(query), {
    onError: () =>
      toast.error('Não foi possível carregar o peso do produto', {
        toastId: 'loadProductWeight'
      })
  })
}
